const mutations = {
  ["ConsumerEmpBoxesFlagMut"](state, payload) {
    state.consumerEmpBoxesFlag = payload;
  },
  ["InsuranceBoxFlagMut"](state, payload) {
    state.insuranceBoxFlag = payload;
  },
  ["personalizedFlagMut"](state, payload) {
    state.personalizedFlag = payload;
  },
};
export default mutations;
